export default {
  update(el, binding) {
    setTimeout(() => {
      if (binding.value === true) {
        el.getElementsByTagName('div')[0].style.display = 'none';
      }
    });
  }
};
